import {
    Material,
    Primitive,
    GeometryInstance,
    EllipseGeometry,
    EllipsoidSurfaceAppearance,
    Color,
    Cartesian3,
    Matrix4,
    ShadowMode
} from 'cesium';
import transformRgb from "../_util/transformRgb";

const circleSource = `
czm_material czm_getMaterial(czm_materialInput materialInput)
{
    czm_material material = czm_getDefaultMaterial(materialInput);
    vec2 st = materialInput.st;
    vec3 diffuse = color.rgb;
    float alpha = 0.0;
    float u_time = (czm_frameNumber / 60.0);
    float dis = distance(st, vec2(0.5));


    alpha = 0.0;

    if(dis <  fract(u_time * 0.5) / 2.0 ) {
      diffuse = color.rgb;
    }

    if(dis <  fract(u_time * 0.5 - 0.5) / 2.0 ) {
      diffuse = color.rgb;
      alpha = dis / fract(u_time * 0.5 - 0.5);
    }


    material.diffuse = diffuse;
    material.alpha = alpha;
    return material;
}`


class ThreePointLayer {
    constructor(options) {
        const {show = true} = options;
        this.map = options.map;

        this.data = options.data;

        this.color = options.color;

        this.primitives = [];

        this.show = show;

        if (this.data?.length) {
            this.loadData(this.data)
        }
    }

    set show(value) {
        if (this.primitives?.length) {
            this.primitives.map(primitive => {
                primitive.show = value;
            })
        }
    }

    loadData(data) {
        this.data = data;
        const map = this.map;
        const show = this.show;

        this.destroy();

        this.primitives = [];

        const colors = {};

        data.map((item) => {
            let {data, radius} = item;


            let color_str = item.color || this.color || '#0080ff';

            // 缓存颜色
            colors[color_str] = colors[color_str] || {
                item,
                _instances: [],
                color: color_str
            };

            // 缓存颜色对应的数据
            colors[color_str]._instances.push(new GeometryInstance({
                geometry: new EllipseGeometry({
                    center: Cartesian3.fromDegrees(...data),
                    radio: new Cartesian3(10.0,10.0,10.0),
                    semiMajorAxis: radius || 100.0,
                    semiMinorAxis: radius || 100.0,
                }),
            }))
        });

        for (let color_str in colors) {
            const {color, _instances} = colors[color_str];

            const circle = new Primitive({
                geometryInstances: _instances,
                show,
                appearance: new EllipsoidSurfaceAppearance({
                    material: new Material({
                        fabric: {
                            type: 'mym',
                            uniforms: {
                                color: Color.fromCssColorString(transformRgb(color, 1)), // 颜色
                            },
                            source: circleSource,
                        },
                    }),
                }),
                modelMatrix: Matrix4.IDENTITY,
                vertexCacheOptimize: false,
                interleave: false,
                compressVertices: true,
                releaseGeometryInstances: true,
                allowPicking: true,
                cull: true,
                asynchronous: true,
                debugShowBoundingVolume: false,
                shadows: ShadowMode.DISABLED
            })
            map.scene.primitives.add(circle);
            this.primitives.push(circle);
        }
    }

    destroy() {
        const map = this.map;

        if (this.primitives?.length) {
            this.primitives.map(primitive => {
                map.scene.primitives.remove(primitive);
            })
            this.primitives = null;
        }
    }
}

export default ThreePointLayer;
